import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import featureStateSelector from './featureStateSelector'
import { ProductColorsState } from '../types'

export const totalSelector = createSelector<ReduxState, ProductColorsState, number>(
  featureStateSelector,
  state => state.pagination.total
)
